import { FC, ReactElement, useEffect, useCallback } from "react";

import MySwal from "../../sweetalert";

interface Props {
  title?: string;
  text?: string;
  confirmButtonText?: string;
  onDismiss: Function; // TODO: research this
  show: boolean;
}

const ErrorPrompt: FC<Props> = (props: Props): ReactElement => {
  const showAlert = useCallback(() => {
    MySwal.fire({
      title: props.title ? props.title : "Something went wrong",
      text: props.text,
      icon: "error",
      backdrop: true,
      confirmButtonText: props.confirmButtonText
        ? props.confirmButtonText
        : "Dismiss",
    }).then(() => {
      props.onDismiss();
    });
  }, [props]);

  useEffect(() => {
    if (props.show) {
      showAlert();
    }
  }, [props.show, showAlert]);

  return <></>;
};

export default ErrorPrompt;
